import api from '@pray/shared/utils/api';

export type SystemCheckDailyItem = {
  daily_public_id: string;
  title: string;
  is_processing: boolean;
  background_image_url: string | null;
  quote: string | null;
  artist_name: string;
  artist_public_id: string;
  created_at: string;
  scheduled_at: string | null;
};

export type SystemCheckDailiesResponse = {
  data: SystemCheckDailyItem[];
  pagination: {
    next_cursor: string | null;
    has_more: boolean;
    total_count: number;
  };
};

export type GetSystemCheckDailiesParams = {
  cursor?: string | null;
  limit?: number;
};

export async function getSystemCheckDailies({
  cursor = null,
  limit = 50,
}: GetSystemCheckDailiesParams = {}): Promise<SystemCheckDailiesResponse> {
  const params: Record<string, string | number> = { limit };

  if (cursor) params.cursor = cursor;

  const url = '/web/studio/system-check/dailies';
  const response = await api.executeGetRequest<{ data: SystemCheckDailiesResponse }>(url, params);

  return response.data.data;
}
